import React from "react";
import CreateAttributeList, { attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import { SectionIcon } from "../Icons/ComponentIcons";
import LayoutNode, { AttributeCollection, getNodeComponentAttributeValue} from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import  { stringifyLayout } from "../WebDesigner";
import { WBComponent, ResizeableType } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import RenderSection from "./Renders/RenderSection";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { SiteData } from "../Data/SiteData";
import { UpdateStyleFunction } from "../Stylebuilder";
import { OpenSaveAsSectionMenu, SectionSaveType } from "../Menus/SaveSectionMenu";
import { editTextPlaceHolder } from "../Data/WBComponentDefaults";
import { LoginUserType } from "utils/Utils";







export default class Section extends WBComponent {



    constructor() {
        super();
        this.typename = wBComponentTypeNames.section;
        this.resizeType = ResizeableType.VerticalOnly;
        this.resizeVisibilty = [true, true,  false]
        this.displayName = "Section";
        this.editList = [
            "overflow",
            "tag",

            attributeTypes.padding,
            "sectionType",
            "reverseColumnsMobile",
            attributeTypes.height,
            attributeTypes.borderColor,
            attributeTypes.borderWidth,
            attributeTypes.borderStyle,
            attributeTypes.boxShadow,
            attributeTypes.margin,

            ...CreateAttributeList(false,true,true,false,false,false).filter(a=>a!="width")
        ];
        this.dropList = [wBComponentTypeNames.pageRoot];
        this.primaryEditAttributes = ["sectionType","reverseColumnsMobile","tag"]

        this.showTemplateOptions = true;
        this.icon = <SectionIcon/>


    }



    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {



        const ads =  [
            new AttributeDefinition("sectionType","Content Width","",AttributeInputType.ButtonField,
            [{label:"Fit to Page",value:""},{label:"Full Width",value:"expanded"}]

            ),
            new AttributeDefinition("reverseColumnsMobile","Reverse Columns on Mobile","",AttributeInputType.ButtonField,
            [{label:"Don't Reverse",value:""},{label:"Reverse",value:"reverse"}]),



            ];

        let tagDef =   new AttributeDefinition("tag","Section Tag","",AttributeInputType.InputFiled);
        tagDef.description = "Tags allow sections to be scrolled to from a button link."
        tagDef.placeHolder = "Enter a tag name"

        return [...ads,tagDef];

    }

    RenderMenu({ editList, primaryList, layoutNode, screenSize, updateFunc, saveFunc, showScreenSize, siteData, }: { updateFunc: UpdateStyleFunction; saveFunc: Function; editList: string[]; primaryList: string[]; layoutNode: AttributeCollection | null; screenSize: ScreenSize; showScreenSize?: boolean | undefined; siteData: SiteData; }): JSX.Element {

        let node = layoutNode as LayoutNode;

        return  <>{super.RenderMenu({ editList, primaryList, layoutNode, screenSize, updateFunc, saveFunc, showScreenSize, siteData })}
        {siteData.userContext.userType == LoginUserType.VagaroAdmin &&
        <div className="flex-column gap-med"
        style={{
            position: "absolute",
            bottom:" 0px",
            width: "272px",
            left: "16px",
            zIndex: 50,
            background: "#f8f8f8",
            paddingTop: "8px",
            paddingBottom: "8px",
      }}

        >
            {!node.content|| node.content.length < 3 || node.content == editTextPlaceHolder ? // non linked sections
                <>
            <button
            className="w-button w-button-primary w-full"
                onClick={() => {

                    let newNode = {...node};
                    newNode.content = editTextPlaceHolder; // clear content ref so it does show as "update" when adding section

                    let content = stringifyLayout(newNode);

                    OpenSaveAsSectionMenu(content, siteData);
                }}
            >Save Section</button>
                </>
                :
               <>
                <button
                className="w-button w-button-secondary w-full"
                onClick={() => {node.content = editTextPlaceHolder; saveFunc();}}
                >
                    Cancel
                </button>

                <button
                className="w-button w-button-primary w-full"
                onClick={() => {
                    let newNode = {...node};
                    newNode.content = editTextPlaceHolder; // clear content ref so it does show as "update" when adding section
                    let content = stringifyLayout(newNode);
                    if(node.content){

                        OpenSaveAsSectionMenu(content, siteData,node.content,SectionSaveType.EditContent);

                    }
                }}
                >Update Section</button>
           </>
            }
            </div>
            }
        </>
    }

    RenderLayout({component,children,screenSize,userContext: siteData,isEditor}:WBRenderProps){

        const reverse = getNodeComponentAttributeValue(component,"reverseColumnsMobile") == "reverse"?"reverse":"";

        return (
            <RenderSection atts={GetNodeDomAttributes("v-section "+reverse,component,screenSize,isEditor)}
             component={component} screenSize={screenSize} userContext={siteData} isEditor={isEditor}>{children}</RenderSection>
        )



    }

}